<template>
    <div>
       <van-nav-bar
  title="提现"
  left-arrow
  @click-left="$router.go(-1)"
/>
<van-cell title="可提现金额" :value="extcredits1+'元'" />
 <van-field
    v-model="money"
    required
    clearable
    label="提现金额"
    placeholder="请输入提现金额"
  />
  <van-cell title="提现账号" v-if="alipay" :value="alipay.ali_account" />
  <van-cell title="提现账号" v-else is-link to="/alipay?goBack=1" />

  <van-button type="danger" size="large" @click="withdraw()">提现</van-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
     data() {
      return {
          alipay:null,
          extcredits1:'', //可提现余额
          money:'', //想提现的金额
      }
    },
    created(){
        this.Post({
        }, "/main/AlipayInfo", res => {
            if (res.states == 1) {
                 this.alipay = res.data.alipay
                 this.extcredits1 = res.data.extcredits1/100
            }else{
                this.Toast.fail(res.msg);
            }
        });
    },
    computed: {
       ...mapState(['deposit']),
    },
    methods:{
        // 申请提现
        withdraw(){
            const id = this.alipay? this.alipay.Id: ''
        this.Post({
            Alipay_id:id,
            money:(this.money*100)
        }, "/main/withdraw", res => {
            if (res.states == 1) {
                this.extcredits1 = this.extcredits1 - this.money
                this.Dialog.alert({
                     message: '申请提现成功，客服会在24小时处理',
                })
            }else{
                this.Toast.fail(res.msg);
            }
        });
        },
    },
}
</script>

<style lang="less" rel="stylesheet/less" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/mine/withdraw.vue